import React from 'react'

const Card = props => {
    const { image, title, text } = props

    return (
        <div className="card mb-4 box-shadow">
            {image && <img className="card-img-top" src={image} alt="" data-holder-rendered="true" />}
            {text && <div className="card-body">
                {title && <h4 className="card-title">{title}</h4>}
                <p className="card-text">{text}</p>
            </div>}
        </div>
    )
}

export default Card


// WEBPACK FOOTER //
// ./src/components/Card.js